import { PRODUCT_WIDGETS_VS_COMPONENTS, RESPONSIVE_WIDGET } from '@configs/productWidget.config'
import { getClassNames } from '@helpers/productWidgetHelper'
import { ABHA_SEO_WIDGET } from '@components/Product/ProductWidget/constants'
import { isVasWidget } from '@helpers/vasLandingPageHelper'
import styles from '../productWidget.module.scss'

const ProductLobWidget = ({
  content,
  isMobileDevice,
  segmentEventCommonProperties,
  reqCookie,
  isSemPage,
  isOldLayout,
  regexPatternsData,
  widgetVisibleAlways = false,
  isHealthWidgetPurpleLayout = false,
  isNewBackgroundImgLayout = false,
  widgetOptions,
}) => {
  if (!content || !RESPONSIVE_WIDGET.includes(content?.widget)) {
    return null
  }

  const Component = PRODUCT_WIDGETS_VS_COMPONENTS[content?.widget]
  const isVasLandingWidget = isVasWidget(content?.widget)

  const productLobWidgetContainerClassNames = getClassNames([styles.componentContainer], {
    [styles.seoDontRenderContent]: isHealthWidgetPurpleLayout && !widgetVisibleAlways,
    [styles.addMarginTop]: isHealthWidgetPurpleLayout && content?.widget === ABHA_SEO_WIDGET,
    [styles.newBackgroundImgLayout]: isNewBackgroundImgLayout,
    [styles.makeSpaceforWidget]: isVasLandingWidget,
  })

  const desktopMwebContainerClassNames = getClassNames([], {
    [styles.widgetVisibleAlways]: widgetVisibleAlways,
    [styles.makeSpaceChildContainer]: isVasLandingWidget,
  })

  return (
    <div className={productLobWidgetContainerClassNames}>
      <div className={desktopMwebContainerClassNames}>
        <Component
          isMobileDevice={isMobileDevice}
          segmentEventCommonProperties={segmentEventCommonProperties}
          reqCookie={reqCookie}
          isSemPage={isSemPage}
          isOldLayout={isOldLayout}
          regexPatternsData={regexPatternsData}
          {...content}
          {...widgetOptions}
        />
      </div>
    </div>
  )
}

export default ProductLobWidget
